import React, { useState, useEffect, useMemo } from "react";
import FormHelperText from "@mui/material/FormHelperText";
import { CellWrapper } from "./cellWrapper";
// import {
//   ThemeProvider,
//   unstable_createMuiStrictModeTheme,
// } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { theme2 } from "app/audit/theme";
import { KeyboardDatePicker } from "components/styledComponent/datetime";
import {
  getParsedDate,
  isValidDate,
} from "components/utils/utilFunctions/function";
import { format, isValid } from "date-fns";
import { usePropertiesConfigContext } from "components/context/propertiesConfig/customProperties";
import { useAuthContext } from "components/context/authContext/authContext";

// const themeObj = unstable_createMuiStrictModeTheme(theme2);
export const EditableDatePicker = (props) => {
  const { commonDateFormat } = usePropertiesConfigContext();
  const [selectedSection, setSelectedSection] = useState<any>(null);
  const { authState } = useAuthContext();
  const {
    value: initialValue,
    rows,
    row: { index, original },
    column: {
      id,
      validation,
      dateFormat,
      mindate,
      maxdate,
      disablePast,
      disableFuture,
      disableToday,
      isReadOnly,
      __EDIT__,
    },
    updateGridData,
    hiddenFlag,
    loading,
  } = props;
  const externalTouched = Boolean(original?._touched?.[id]);
  const externalError = original?._error?.[id] ?? "";
  const [loadingcall, setLoading] = useState(false);
  const [value, setValue] = useState(initialValue);

  const isReadOnlyLocal = useMemo(() => {
    if (original?._isReadOnly === true) {
      return true;
    }
    if (original?._isNewRow === true) {
      return false;
    }
    if (isReadOnly) {
      return true;
    }
    if (original?._isNewRow === false && __EDIT__?.isReadOnly === true) {
      return true;
    }
    return false;
  }, [isReadOnly, original, __EDIT__]);

  const prevRows = rows
    .slice(0, index)
    .map((one) => one?.original)
    .filter((one) => Boolean(one[hiddenFlag]) !== true);

  const nextRows = rows
    .slice(index + 1)
    .map((one) => one?.original)
    .filter((one) => Boolean(one[hiddenFlag]) !== true);

  const onChange = (date) => {
    setValue(date);
    // setLoading(true);
    validation(date, original, prevRows, nextRows).then((result) => {
      // setLoading(false);
      const dateObj = date ? new Date(date) : date;
      let newValue = isValidDate(dateObj)
        ? format(dateObj, "yyyy-MM-dd HH:mm:ss.S")
        : dateObj;
      updateGridData(index, id, newValue, true, result);
    });
  };

  const onBlur = () => {
    setLoading(true);
    validation(value, original, prevRows, nextRows).then((result) => {
      setLoading(false);
      const dateObj = value ? new Date(value) : value;
      let newValue = isValidDate(dateObj)
        ? format(dateObj, "yyyy-MM-dd HH:mm:ss.S")
        : dateObj;
      updateGridData(index, id, newValue, true, result);
    });
  };

  /** Functionality for CBS: To set future or past date based on working date on arrow up / down key press when field is empty.
   * And to move cusror to start or end on pressing home / end key.
   */
  const handleKeyDown = (e) => {
    const localFormat = dateFormat ?? commonDateFormat;
    if (
      authState?.workingDate &&
      (e.key === "ArrowUp" || e.key === "ArrowDown")
    ) {
      const date = e.target.value;
      // condition to check if field is empty with format checking
      if (
        !isValid(value) &&
        date?.toLowerCase() === localFormat?.toLowerCase()
      ) {
        const workingDate = authState?.workingDate;
        let currDate: number | string = "";
        if (e.key === "ArrowUp") {
          // next date from working date if pressed arrow up
          currDate = new Date().setDate(new Date(workingDate).getDate() + 1);
        } else if (e.key === "ArrowDown") {
          // previous date from working date if pressed arrow down
          currDate = new Date().setDate(new Date(workingDate).getDate() - 1);
        }

        setTimeout(() => onChange(new Date(currDate)), 0);
      }
    } else if (e.key === "Home") {
      // set selection to first section
      setSelectedSection(0);
    } else if (e.key === "End") {
      // set selection to last section
      const delimiter = localFormat.includes("/")
        ? "/"
        : localFormat.includes("-")
          ? "-"
          : null;
      const sectionCount = delimiter ? localFormat.split(delimiter).length : 1;
      setSelectedSection(sectionCount - 1);
    }
  };

  useEffect(() => {
    // let initialDate = initialValue;
    // if (!initialDate) {
    //   initialDate = new Date();
    // }
    setValue(initialValue);
  }, [initialValue]);

  return (
    <CellWrapper showBorder {...props}>
      {/* <ThemeProvider theme={themeObj}> */}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <KeyboardDatePicker
          format={
            (Boolean(dateFormat) ? dateFormat : commonDateFormat) ||
            "dd/MM/yyyy"
          }
          onChange={onChange}
          value={value === "" || value === null ? null : getParsedDate(value)}
          disabled={loadingcall || loading}
          readOnly={isReadOnlyLocal}
          minDate={mindate || new Date("1900-01-01")}
          maxDate={maxdate || null}
          disablePast={disablePast}
          disableFuture={disableFuture}
          onSelectedSectionsChange={(section) => {
            setSelectedSection(section);
          }}
          selectedSections={selectedSection}
          // error={Boolean(externalTouched) && Boolean(externalError)}
          slotProps={{
            textField: {
              onBlur,
              onKeyDown: handleKeyDown,
              "aria-label": "Select Date",
              name: id,
              autoComplete: "off",
              InputLabelProps: { shrink: true },
              InputProps: { disableUnderline: true },
            },
            actionBar: {
              actions: disableToday
                ? ["accept", "cancel"]
                : ["today", "accept", "cancel"],
            },
          }}
        />
      </LocalizationProvider>
      {/* </ThemeProvider> */}
      {Boolean(externalTouched) && Boolean(externalError) ? (
        <FormHelperText style={{ whiteSpace: "break-spaces" }} error={true}>
          {externalError}
        </FormHelperText>
      ) : null}
    </CellWrapper>
  );
};
